'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const buildSearchParams = (params) => {
    const definedParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            return Object.assign(Object.assign({}, acc), { [key]: String(value) });
        }
        return acc;
    }, {});
    return new URLSearchParams(definedParams);
};

exports.buildSearchParams = buildSearchParams;
//# sourceMappingURL=build-search-params.js.map
